import {
  GET_SYS_SETTINGS_FAIL,
  GET_SYS_SETTINGS_REQUEST,
  GET_SYS_SETTINGS_RESET,
  GET_SYS_SETTINGS_SUCCESS,
  UPDATE_SYS_SETTINGS_FAIL,
  UPDATE_SYS_SETTINGS_REQUEST,
  UPDATE_SYS_SETTINGS_SUCCESS,
} from "./sysSettingsType";

export const sysSettingsReducer = (state = { chat: [] }, action) => {
  switch (action.type) {
    case GET_SYS_SETTINGS_REQUEST:
      return { ...state, loading: true };

    case GET_SYS_SETTINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        settingData: action.payload,
      };

    case GET_SYS_SETTINGS_FAIL:
      return { ...state, loading: false, error: action.payload };
    case GET_SYS_SETTINGS_RESET:
      return { ...state, loading: false, settingData: null };

    // Single Update
    case UPDATE_SYS_SETTINGS_REQUEST:
      return { ...state, loading: true };

    case UPDATE_SYS_SETTINGS_SUCCESS:
      return { ...state, loading: false, settingData: action.payload };

    case UPDATE_SYS_SETTINGS_FAIL:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
